import toast from "react-hot-toast";
import { LuLayoutDashboard } from "react-icons/lu";
import { CiViewList } from "react-icons/ci";
import { MdOutlinePermContactCalendar } from "react-icons/md";
import { IoLogInOutline } from "react-icons/io5";
import { GrTransaction } from "react-icons/gr";
import { PiUserList,PiHandWithdraw  } from "react-icons/pi";
import { RiDeleteBin3Line } from "react-icons/ri";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { BsGraphUp } from "react-icons/bs";
import { FaExchangeAlt } from "react-icons/fa";

export const getLocalStorageItem = (key) => {
  const item = localStorage.getItem(key);

  if (item === null) {
    return null;
  }

  try {
    return JSON.parse(item);
  } catch (error) {
    return item;
  }
};


export const setLocalStorageItem = (key, value) => {
  try {
    const valueToStore = typeof value === "string" ? value : JSON.stringify(value);
    localStorage.setItem(key, valueToStore);
  } catch (error) {
    console.log("error in setLocalStorageItem", error);
  }
};

export const removeLocalStorageItem = (key) => localStorage.removeItem(key);

export const notifySuccess = (message) => {
  toast.success(message, {
    duration: 2500,
    position: "top-center",
  });
};

export const notifyError = (message) => {
  toast.error(message, {
    duration: 2500,
    position: "top-center",
  });
};

export const notifyPromise = (promise, message) => {
  return toast.promise(
    promise.then((res) => {
      if (res?.data?.meta?.code === 200 || res?.data?.meta?.message === 200) {
        return res;
      } else {
        throw { response: res };
      }
    }),
    {
      loading: message || "Loading...",
      success: (res) => `${res?.data?.meta?.message || "Success."}`,
      error: (err) => `${err?.response?.data?.meta?.message || err?.response?.data?.message|| "Failed"}`,
    }
  );
};

export const notifyErrorWithButton = (message, buttonText, passedFunction) => {
  const toastId = toast.error(
    <div className="notifyErrorWithButton">
      <span>{message}</span>
      <button
        onClick={() => {
          passedFunction();
          toast.dismiss(toastId);
        }}
        style={{
          marginLeft: "10px",
          padding: "0.5em 1em",
          background: "#f44336",
          color: "#fff",
          border: "none",
          borderRadius: "3px",
          cursor: "pointer",
        }}
      >
        {buttonText}
      </button>
    </div>,
    {
      duration: 2500,
      position: "top-center",
      closeOnClick: false,
    }
  );
};

export const getUserIP = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
 
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP:", error);
    return null;
  }
};

export const getSideMenuIcon = (key) => {
  const iconMap = {
    LuLayoutDashboard: <LuLayoutDashboard />,
    CiViewList: <CiViewList />,
    MdOutlinePermContactCalendar: <MdOutlinePermContactCalendar />,
    IoLogInOutline: <IoLogInOutline />,
    PiHandWithdraw: <PiHandWithdraw />,
    GrTransaction: <GrTransaction />,
    RiDeleteBin3Line: <RiDeleteBin3Line />,
    PiUserList: <PiUserList/>,
    AiOutlineUsergroupAdd: <AiOutlineUsergroupAdd/>,
    BsGraphUp: <BsGraphUp />,
    FaExchangeAlt: <FaExchangeAlt />
  };

  return iconMap[key] || null;
};

export const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

export const extractUsersFromData = (data) => {
  if (!data) return [];

  // Handle direct array structure
  if (Array.isArray(data)) {
    return data;
  }

  // Handle object with users array
  if (Array.isArray(data?.users)) {
    return data.users;
  }

  // Handle object with data property containing array
  if (Array.isArray(data?.data)) {
    return data.data;
  }

  // Handle object with data property containing users array
  if (Array.isArray(data?.data?.users)) {
    return data.data.users;
  }

  // Default to empty array
  return [];
};